import React from "react";
import "./MainLayout.scss";

const MainLayout = ({ ...props }) => {
    return (
        <div className="main-layout">
            <div className="subBackgroundLayout">
            {props.children}
            </div>
        </div>
    );
};

export default MainLayout;
